export var ECollapsingModelKind;
(function (ECollapsingModelKind) {
    ECollapsingModelKind["Gene"] = "gene_level";
    ECollapsingModelKind["Variant"] = "variant_level";
    ECollapsingModelKind["Phenotype"] = "phenotype_level";
})(ECollapsingModelKind || (ECollapsingModelKind = {}));
